/* START: Featured Blog Carousel Script */ 

document.addEventListener( 'DOMContentLoaded', function () {
  new Splide('.FeaturedBlog-carousel-init', {
    type: 'loop',
    perPage: 3.6,
    focus: 'center',
    autoplay: false,
    interval: 8000,
    flickMaxPages: 3.6,
    updateOnMove: true,
    pagination: true,
    padding: '10%',
    throttle: 300,
     classes: {
		arrows: 'FeaturedBlog-carousel__arrow-container',
		arrow : 'FeaturedBlog-carousel__arrow',
		prev  : 'splide__arrow--prev',
		next  : 'splide__arrow--next',
      },
      breakpoints: {
      991: {
        perPage: 2.8,
        padding: '30%'
      },
       699: {
        focus: 'center',
        perPage: 1.8,
       arrows: false
      },
       499: {
        focus: 'center',
        perPage: 1,
       arrows: false
      }
    }
  }).mount();
});

/* END: Featured Blog Carousel Script */ 

// Blog page search Script
 document.addEventListener('DOMContentLoaded', function () {
        const searchInput = document.getElementById('searchInput');
        const searchResults = document.getElementById('searchResults');
        const articles = document.querySelectorAll('.articles');

        searchInput.addEventListener('keyup', function () {
          const searchTerm = searchInput.value.toLowerCase();
          const matchingArticles = [];

          articles.forEach(function (article) {
            const title = article.getAttribute('data-title').toLowerCase();

            if (title.includes(searchTerm)) {
              matchingArticles.push(article.cloneNode(true));
            }
          });

          displayResults(matchingArticles);
        });

     searchInput.addEventListener('keyup', function () {
                  if ( searchInput.value === '') {
                      hideSearchResults();
                  }
              });

     document.addEventListener('click', function(event) {
      const clickedElement = event.target;
      if (!searchInput.contains(clickedElement) && clickedElement !== searchResults) {
        hideSearchResults();
      }
    });

        function displayResults(results) {
          searchResults.innerHTML = '';

          if (results.length > 0) {
            results.forEach(function (result) {
              const li = document.createElement('li');
              li.innerHTML = result.outerHTML;
              searchResults.appendChild(li);
            });
            searchResults.style.display = 'block';
          } else {
            const li = document.createElement('li');
            li.textContent = 'No results found';
            searchResults.appendChild(li);
            searchResults.style.display = 'block';
          }
        }
     function hideSearchResults() {
                  searchResults.style.display = 'none'; // Hide results list
              }

      });

